import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useReducer } from 'react';
import { getExtensionOptions } from '../../../../../components/utils/tiptap';
import { addMissingProtocol, validateHref } from '../../../../../components/utils/validateHref';
function settingsReducer(state, action) {
    switch(action.type){
        case 'setLayout':
            return _object_spread_props(_object_spread({}, state), {
                layout: action.layout
            });
        case 'setWidth':
            return _object_spread_props(_object_spread({}, state), {
                width: action.width
            });
        case 'setAlignment':
            return _object_spread_props(_object_spread({}, state), {
                alignment: action.alignment
            });
        case 'setGridItemWidth':
            return _object_spread_props(_object_spread({}, state), {
                gridItemWidth: action.width
            });
        case 'setGridItemHeight':
            return _object_spread_props(_object_spread({}, state), {
                gridItemHeight: action.height
            });
        case 'setLayoutSpacing':
            return _object_spread_props(_object_spread({}, state), {
                layoutSpacing: action.value
            });
        case 'setTorpedoRowHeight':
            return _object_spread_props(_object_spread({}, state), {
                torpedoRowHeight: action.value
            });
        case 'setItemCropping':
            return _object_spread_props(_object_spread({}, state), {
                itemCropping: action.value
            });
        case 'setRowAlignment':
            return _object_spread_props(_object_spread({}, state), {
                layoutRowAlignment: action.value
            });
        case 'updateLink':
            var _state_linkOverrides;
            return _object_spread_props(_object_spread({}, state), {
                linkOverrides: _object_spread_props(_object_spread({}, (_state_linkOverrides = state.linkOverrides) !== null && _state_linkOverrides !== void 0 ? _state_linkOverrides : {}), {
                    [action.deviationId]: action.link
                })
            });
        default:
            throw new Error();
    }
}
export default function useSettingsState(editor) {
    const attrs = editor.getAttributes('da-gallery');
    const options = getExtensionOptions(editor, 'da-gallery');
    var _attrs_width, _attrs_alignment, _attrs_gridItemWidth, _attrs_gridItemHeight, _attrs_itemCropping, _attrs_layoutRowAlignment, _attrs_layoutSpacing, _attrs_torpedoRowHeight;
    const initialState = {
        layout: attrs.layout,
        width: (_attrs_width = attrs.width) !== null && _attrs_width !== void 0 ? _attrs_width : options.defaultWidth,
        alignment: (_attrs_alignment = attrs.alignment) !== null && _attrs_alignment !== void 0 ? _attrs_alignment : 'center',
        gridItemWidth: (_attrs_gridItemWidth = attrs.gridItemWidth) !== null && _attrs_gridItemWidth !== void 0 ? _attrs_gridItemWidth : options.defaultGridItemWidth,
        gridItemHeight: (_attrs_gridItemHeight = attrs.gridItemHeight) !== null && _attrs_gridItemHeight !== void 0 ? _attrs_gridItemHeight : options.defaultGridItemHeight,
        itemCropping: (_attrs_itemCropping = attrs.itemCropping) !== null && _attrs_itemCropping !== void 0 ? _attrs_itemCropping : 'crop',
        layoutRowAlignment: (_attrs_layoutRowAlignment = attrs.layoutRowAlignment) !== null && _attrs_layoutRowAlignment !== void 0 ? _attrs_layoutRowAlignment : 'left',
        layoutSpacing: (_attrs_layoutSpacing = attrs.layoutSpacing) !== null && _attrs_layoutSpacing !== void 0 ? _attrs_layoutSpacing : options.defaultLayoutSpacing,
        torpedoRowHeight: (_attrs_torpedoRowHeight = attrs.torpedoRowHeight) !== null && _attrs_torpedoRowHeight !== void 0 ? _attrs_torpedoRowHeight : options.defaultTorpedoRowHeight,
        linkOverrides: attrs.linkOverrides
    };
    const [state, dispatch] = useReducer(settingsReducer, initialState);
    const setGalleryLayout = (e)=>{
        const layout = e.target.value;
        dispatch({
            type: 'setLayout',
            layout
        });
        editor.commands.daGalleryChangeLayout(layout);
    };
    const setGalleryWidth = (e)=>{
        const width = e;
        dispatch({
            type: 'setWidth',
            width: +width
        });
        editor.commands.daGallerySetWidth(width);
    };
    const setGalleryAlignment = (selected, alignment)=>{
        dispatch({
            type: 'setAlignment',
            alignment
        });
        editor.commands.daGalleryAlign(alignment);
    };
    const setGridItemWidth = (width)=>{
        dispatch({
            type: 'setGridItemWidth',
            width
        });
        editor.commands.daGallerySetGridItemWidth(width);
    };
    const setGridItemHeight = (height)=>{
        dispatch({
            type: 'setGridItemHeight',
            height
        });
        editor.commands.daGallerySetGridItemHeight(height);
    };
    const setLayoutSpacing = (value)=>{
        dispatch({
            type: 'setLayoutSpacing',
            value
        });
        editor.commands.daGallerySetLayoutSpacing(value);
    };
    const setTorpedoRowHeight = (value)=>{
        dispatch({
            type: 'setTorpedoRowHeight',
            value
        });
        editor.commands.daGallerySetTorpedoRowHeight(value);
    };
    const setItemCropping = (selected, value)=>{
        dispatch({
            type: 'setItemCropping',
            value
        });
        editor.commands.daGallerySetItemCropping(value);
    };
    const setRowAlignment = (selected, value)=>{
        dispatch({
            type: 'setRowAlignment',
            value
        });
        editor.commands.daGallerySetRowAlignment(value);
    };
    const updateLinkFor = (deviationId, link)=>{
        const action = {
            type: 'updateLink',
            deviationId,
            link
        };
        const newState = settingsReducer(state, action);
        dispatch(action);
        if (link === '' || validateHref(addMissingProtocol(link))) {
            editor.commands.daGallerySetLinkOverrides(newState.linkOverrides);
        }
    };
    return {
        state,
        setGalleryLayout,
        setGalleryWidth,
        setGalleryAlignment,
        setGridItemWidth,
        setGridItemHeight,
        setLayoutSpacing,
        setTorpedoRowHeight,
        setItemCropping,
        setRowAlignment,
        updateLinkFor
    };
}

//# sourceMappingURL=useSettingsState.js.map